import React from 'react';
import GCamFE from './GCamFE/GCamFE';
import GCamCond from './GCamCond/GCamCond';
import GCamItem from './GCamItem/GCamItem';
import GCamNRE from './GCamNRE/GCamNRE';
import GTransp from './GTransp/GTransp';
import GCamSal from './GCamSal/GCamSal';
import GCamEnt from './GCamEnt/GCamEnt';
import GVehTras from './GVehTras/GVehTras';
import GCamTrans from './GCamTrans/GCamTrans';
import GCamNCDE from './GCamNCDE/GCamNCDE';
import GCamAE from './GCamAE/GCamAE';

const GDTipDE = (props) => {
    const renderComponent = () => {
        return (
            <div data-testid={props.testId}>
                {props.formik.values.tipo_de?.i_ti_de === 1 && <GCamFE testId="gcamfe" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {props.formik.values.tipo_de?.i_ti_de === 4 && <GCamAE formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {(props.formik.values.tipo_de?.i_ti_de === 1 || props.formik.values.tipo_de?.i_ti_de === 4) && (
                    <GCamCond testId="gcamcond" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />
                )}
                {props.formik.values.tipo_de?.i_ti_de === 7 && <GCamNRE testId="gcamnre" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {props.formik.values.tipo_de?.i_ti_de === 7 && <GTransp testId="gtransp" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {props.formik.values.tipo_de?.i_ti_de === 7 && <GCamSal testId="gcamsal" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {props.formik.values.tipo_de?.i_ti_de === 7 && <GCamEnt testId="gcament" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {props.formik.values.tipo_de?.i_ti_de === 7 && <GVehTras testId="gcamvehtras" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {props.formik.values.tipo_de?.i_ti_de === 7 && <GCamTrans testId="gcamtrans" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />}
                {(props.formik.values.tipo_de?.i_ti_de === 5 || props.formik.values.tipo_de?.i_ti_de === 6) && (
                    <GCamNCDE testId="gcamncde" formik={props.formik} getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} />
                )}
                <GCamItem formik={props.formik} testId="gcamitem" getFormErrorMessage={props.getFormErrorMessage} isFormFieldInvalid={props.isFormFieldInvalid} onError={props.onError} isEditing={props.isEditing} fieldsLoading={props.fieldsLoading} />
            </div>
        );
    };

    return renderComponent();
};

export default GDTipDE;
